import React, { useState } from "react";
import GetInTouch from "./GetInTouch";



const OFFICES = {
  lagos: {
    key: "lagos",
    label: "Lagos Office",
    address: "27/28 Ringback Mall, Mobil filling station complex, Km 36 Lekki - Epe Expy, express 100001, Lagos.",
    mapSrc:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3964.641856425938!2d3.429357174739132!3d6.440017893551238!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1039574fec1756fd%3A0xb93865e87f8f96bf!2sScaftech%20Engineering%20Services!5e0!3m2!1sen!2sng!4v1740738261988!5m2!1sen!2sng",
  },
  ph: {
    key: "ph",
    label: "Port Harcourt Office",
    address: "Block 6, 3rd Avenue Elekahia Housing Estate, Port Harcourt.",
    mapSrc:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3975.660638129738!2d7.0669074!3d4.828204499999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1069cd172742b501%3A0xc5bbf87d34d5c2ef!2s18%20Trans%20Woji%20Rd%2C%20Rumuwaji%20500102%2C%20Port%20Harcourt%2C%20Rivers!5e0!3m2!1sen!2sng!4v1686763761152!5m2!1sen!2sng",
  },
};

const ContactPage = () => {
  const [activeOffice, setActiveOffice] = useState(OFFICES.lagos);

  const scrollToForm = () => {
    const el = document.getElementById("contact-us");
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <main className="w-full bg-slate-50 text-slate-900">
      {/* OFFICES & LOCATIONS SECTION */}
      <section className="border-b border-slate-200">
        {/* Header */}
        <div className="mx-auto max-w-6xl px-6 pt-24 pb-8 md:pt-28">
          <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
            <div>
              <p className="text-[11px] uppercase tracking-[0.28em] text-slate-500">
                Offices &amp; Locations
              </p>
              <h1 className="mt-1 text-3xl font-semibold md:text-4xl">
                Contact Scaftech Engineering Services
              </h1>
              <p className="mt-3 max-w-xl text-sm text-slate-600 md:text-[0.96rem]">
                Visit or reach our offices in Lagos and Port Harcourt for
                project discussions, inspections, lifting operations, or
                training enquiries. Choose the closest location and connect
                with our team.
              </p>
            </div>

            <div className="flex flex-col items-start gap-3 md:items-end">
              <div className="mt-2 flex flex-wrap gap-2 md:justify-end">
                <span className="inline-flex items-center rounded-full bg-[#062b6c] px-3 py-1 text-[10px] font-medium uppercase tracking-[0.2em] text-slate-50">
                  Nigeria • Multi-location
                </span>
                <span className="inline-flex items-center gap-1 rounded-full border border-[#00ad0f] px-3 py-1 text-[10px] uppercase tracking-[0.2em] text-[#00ad0f]">
                  <span className="h-1.5 w-1.5 rounded-full bg-[#00ad0f]" />
                  Response in 24–48 hrs
                </span>
              </div>

              <button
                type="button"
                onClick={scrollToForm}
                className="mt-1 inline-flex items-center gap-2 rounded-full border border-slate-300 bg-white px-4 py-2 text-xs font-semibold uppercase tracking-[0.2em] text-slate-700 shadow-sm hover:border-[#062b6c] hover:text-[#062b6c]"
              >
                <span>Send us a message</span>
              </button>
            </div>
          </div>
        </div>

        {/* Map + office overview */}
        <div className="mx-auto grid max-w-6xl gap-8 px-6 pb-16 lg:grid-cols-[minmax(0,1.6fr)_minmax(0,1.1fr)]">
          {/* Left: tabs + map */}
          <div className="flex flex-col gap-4">
            {/* Office tabs */}
            <div className="flex gap-2 rounded-full bg-slate-100 p-1">
              {Object.values(OFFICES).map((office) => {
                const isActive = office.key === activeOffice.key;
                return (
                  <button
                    key={office.key}
                    type="button"
                    onClick={() => setActiveOffice(office)}
                    className={`flex-1 rounded-full px-4 py-2 text-xs font-medium uppercase tracking-[0.2em] transition ${
                      isActive
                        ? "bg-[#062b6c] text-slate-50 shadow-sm"
                        : "text-slate-600 hover:bg-slate-200"
                    }`}
                  >
                    {office.label}
                  </button>
                );
              })}
            </div>

            {/* Map */}
            <div className="overflow-hidden rounded-2xl border border-slate-200 bg-slate-100 shadow-sm">
              <iframe
                src={activeOffice.mapSrc}
                width="100%"
                height="420"
                style={{ border: 0 }}
                loading="lazy"
                allowFullScreen
                referrerPolicy="no-referrer-when-downgrade"
                title={activeOffice.label}
              ></iframe>
            </div>

            {/* Active office summary */}
            <div className="flex flex-col gap-2 rounded-2xl border border-slate-200 bg-white p-5 text-sm shadow-sm">
              <h2 className="text-base font-semibold text-slate-900">
                {activeOffice.label}
              </h2>
              <p className="text-slate-600">{activeOffice.address}</p>
              <div className="mt-1 grid gap-2 text-[13px] text-slate-500 md:grid-cols-2">
                <p>
                  <span className="font-medium text-slate-700">Phone:</span>{" "}
                  +234 816 163 7797
                </p>
                <p>
                  <span className="font-medium text-slate-700">Email:</span>{" "}
                  consult@scaftechservices.com
                </p>
              </div>
              <p className="mt-2 text-[12px] text-slate-500">
                Office hours: Mon – Fri, 8:00am – 5:00pm (WAT)
              </p>
            </div>
          </div>

          {/* Right: both offices + quick info */}
          <div className="flex flex-col gap-5">
            <div className="grid gap-4 md:grid-cols-1">
              <div className="rounded-2xl border border-slate-200 bg-white p-5 text-sm shadow-sm">
                <h3 className="text-sm font-semibold text-slate-900">
                  Lagos Office
                </h3>
                <p className="mt-2 text-slate-600">
                  27/28 Ringback Mall, Mobil filling station complex, Km 36 Lekki - Epe Expy, express 100001, Lagos.
                </p>
                <p className="mt-3 text-[12px] text-slate-500">
                  Central hub for coordination, project management, and client
                  engagement across Lagos and the western corridor.
                </p>
              </div>

              <div className="rounded-2xl border border-slate-200 bg-white p-5 text-sm shadow-sm">
                <h3 className="text-sm font-semibold text-slate-900">
                  Port Harcourt Office
                </h3>
                <p className="mt-2 text-slate-600">
                  Block 6, 3rd Avenue Elekahia Housing Estate, Port Harcourt.
                </p>
                <p className="mt-3 text-[12px] text-slate-500">
                  Positioned to support oil &amp; gas, marine, and industrial
                  clients in the Niger Delta and surrounding regions.
                </p>
              </div>
            </div>

            <div className="rounded-2xl border border-dashed border-slate-300 bg-slate-100 p-5 text-[13px] text-slate-600">
              <p className="font-semibold text-slate-800">
                Prefer digital first?
              </p>
              <p className="mt-1">
                Use the contact form below to share project briefs, training
                requests, or inspection enquiries. Our team routes messages to
                the most relevant office internally.
              </p>
              <button
                type="button"
                onClick={scrollToForm}
                className="mt-3 inline-flex items-center gap-2 rounded-full bg-[#062b6c] px-4 py-2 text-[11px] font-semibold uppercase tracking-[0.2em] text-slate-50 hover:bg-[#03112f]"
              >
                Go to contact form
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* FULL-WIDTH GET IN TOUCH SECTION (unchanged component) */}
      <GetInTouch />
    </main>
  );
};

export default ContactPage;